(function () {
  var LINE_HEIGHT_LINES = 3; // lines to show when clamped

  function initDescription(wrapper) {
    if (wrapper.dataset.descExpInit) return;
    wrapper.dataset.descExpInit = '1';

    var inner = wrapper.querySelector('[data-description-expand]');
    var toggle = wrapper.querySelector('[data-description-toggle]');
    var label = wrapper.querySelector('[data-description-toggle-label]');
    if (!inner || !toggle || !label) return;

    var showMoreText = toggle.textContent.trim();
    var showLessText = toggle.dataset.showLess || 'Show less';

    function getClampHeight() {
      var lineHeight = parseFloat(getComputedStyle(inner).lineHeight) || 20;
      return lineHeight * LINE_HEIGHT_LINES;
    }

    function check() {
      // Remove clamp to measure full natural height
      inner.removeAttribute('data-clamped');
      inner.style.removeProperty('--desc-clamp-height');

      var clampedHeight = getClampHeight();

      if (inner.scrollHeight > clampedHeight + 2) {
        // Content overflows — clamp it
        inner.style.setProperty('--desc-clamp-height', clampedHeight + 'px');
        inner.setAttribute('data-clamped', '');
        toggle.hidden = false;
        // Restore expanded state if user had it open
        if (toggle.getAttribute('aria-expanded') === 'true') {
          inner.removeAttribute('data-clamped');
          inner.style.removeProperty('--desc-clamp-height');
          label.textContent = showLessText;
        } else {
          toggle.setAttribute('aria-expanded', 'false');
          label.textContent = showMoreText;
        }
      } else {
        // Fits — no toggle needed, ensure fully visible
        inner.removeAttribute('data-clamped');
        inner.style.removeProperty('--desc-clamp-height');
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        label.textContent = showMoreText;
      }
    }

    toggle.addEventListener('click', function () {
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        // Collapse — re-apply measured clamp height
        inner.style.setProperty('--desc-clamp-height', getClampHeight() + 'px');
        inner.setAttribute('data-clamped', '');
        toggle.setAttribute('aria-expanded', 'false');
        label.textContent = showMoreText;
      } else {
        // Expand
        inner.removeAttribute('data-clamped');
        inner.style.removeProperty('--desc-clamp-height');
        toggle.setAttribute('aria-expanded', 'true');
        label.textContent = showLessText;
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        check();
      }).observe(inner);
    }

    check();
  }

  function initAll() {
    document.querySelectorAll('.product__description').forEach(initDescription);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
